import axios from "axios";

const { REACT_APP_BASE_URL } = process.env;

const client = axios.create({
  timeout: 1000 * 35
});

export const requestInstance = ({ ...options }) => {
  const authToken = sessionStorage.getItem("access_token");
  const userId = sessionStorage.getItem("userId");
  const customerId = sessionStorage.getItem("customerId");
  // console.log("--client", client, options);
  if (authToken === null) {
    // This means that there ISN'T JWT and no user is logged in.
    // client.defaults.headers.common.Authorization = `Bearer`;
  } else {
    // This means that there IS a JWT so someone must be logged in.
    client.defaults.headers.common.Authorization = `Bearer ${authToken}`;
    // client.defaults.headers.common.customerId = `Bearer ${authToken}`;
    client.defaults.headers.common.userId = `${userId}`;
    client.defaults.headers.common.customerId = `${customerId}`;

    // client.defaults.headers.common.role = `Bearer ${authToken}`;
  }

  // client.defaults.headers.common.RoleId= ${token}// roleId
  // client.defaults.headers.common.UserId= // userId

  const onSuccess = (response) => response;
  const onError = (error) => {
    if (error.response) {
      if (error?.response?.status === 401) {
        sessionStorage.clear();
        window.location = REACT_APP_BASE_URL;
      }
      // else if (error?.response?.status === 403) {
      //   const alertPanel = document.getElementById("alert-root");
      //   if (alertPanel) {
      //     alertPanel.style.display = "flex";
      //   }
      // }
    }
    throw error.response;
  };

  return client(options).then(onSuccess).catch(onError);
};
